<template>
  <v-col style="min-width: 100% !important; padding: 0 !important">
    <div>
      <h1 style="color: #64c832">{{ title }}</h1>
    </div>
    <div class="container">
      <v-col class="section" v-for="(section, i) in data" :key="i">
        <div>
            <h2 style="color: #64c832; font-size: 20px;">
              {{ section.subheader }}
            </h2>
        </div>
        <v-row class="body">
          <v-col v-for="(value, key) in section.data" :key="key" class="data">
            <h3 class="name">
              {{
                value && value.label
                  ? value.label
                  : key
                      .toLowerCase()
                      .replace("_", " ")
                      .charAt(0)
                      .toUpperCase() +
                    key.toLowerCase().replace("_", " ").slice(1)
              }}
            </h3>
            <p class="value">
              {{ value && value.value ? value.value : value }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </div>
  </v-col>
</template>

<script>
export default {
  name: "p-display-data",

  props: ["title", "subheader", "data"],
};
</script>

<style scoped>
@import "./styles.css";
</style>